module.exports = "/img/textIcon.2bacecdd.png";